"use strict";
exports.__esModule = true;
exports.HeadlinePaginationRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
exports.HeadlinePaginationRenderer = function (_a) {
    var item = _a.item, showPrevItem = _a.showPrevItem, showNextItem = _a.showNextItem;
    var commonClassNames = "gd-button-link gd-button-icon-only pagination";
    return (react_1["default"].createElement("div", { className: "headline-pagination" },
        react_1["default"].createElement("button", { className: commonClassNames + " first-item gd-icon-chevron-left", onClick: showPrevItem, disabled: item === 1 }),
        react_1["default"].createElement("button", { className: commonClassNames + " second-item gd-icon-chevron-right", onClick: showNextItem, disabled: item === 2 })));
};
//# sourceMappingURL=HeadlinePaginationRenderer.js.map